module.exports = __webpack_public_path__ + "img/sitter2.dc12d4c6.jpg";